module.exports = __webpack_public_path__ + "img/Joy-Stick-Emoji.9b1827d0.png";